import { SimpleTransferOrderUpdatePage } from "@/features/simple-transfer-order/pages/SimpleTransferOrderUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/simple-transfer-order/$id/update")(
  {
    beforeLoad({ context }) {
      if (!context.authAdapter.can({ permissions: ["simple_transfer_order.edit"] })) {
        throw redirect({ to: "/403" });
      }
    },
    component: SimpleTransferOrderUpdatePage,
  }
);
